export const copyString = async (data: string) => {
  await navigator.clipboard.writeText(data);
};

export const copyMetadata = async (data: string[]) => {
  const text = data.join('\n');
  await copyString(text);
};

export const getValue = (data: string) => {
  if (data.includes(':')) {
    return data.split(/:(.*)/s)?.[1].trim();
  } else return data;
};
